/* Important Info component sub page */
import React from 'react';
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import styles from "../../styles/Account.module.css";

const InfoSub = () => {
  return (
    <div className="mb-5">
        <Row className="my-3">
        <Col md={{span: 10, offset: 1}}>
        <div className={`px-3 py-2 ${styles.SubTitle6 }`}>
          <p className={`${styles.Blue} text-center`}>SUBSCRIPTION PLANS INFO</p>
          <hr className={`mt-2 mb-0`}/>
          <p className={`pt-2`}>
          <span className={`${styles.Blue}`}>*</span> Purchase a <span className={`${styles.Blue}`}>Platform Projects with Budgets</span> Subscription Plan 
           then create as many Projects as the Subscription allows on the Account page.
          </p>
          <p className={`pt-2`}>
          <span className={`${styles.Blue}`}>*</span> Purchase a <span className={`${styles.Blue}`}>Budget Only</span> Subscription Plan 
           then create as many Budgets as the Subscription allows from the Budgets link on the Account page.
          </p>
          <p className={`pt-2`}>
          <span className={`${styles.Blue}`}>*</span> The Platform Projects Plans have two 
          categories, <span className={`${styles.Blue}`}>Enterprise</span> and <span className={`${styles.Blue}`}>Standard</span>, based 
          on the amount of Users for each project.
          </p>
          <p className={`pt-2`}>
          <span className={`${styles.Blue}`}>*</span> All Plans in both Enterprise and Standard contain all the Platform features the only 
          difference being the amount of maximum Users.
          </p>
          <p className={`pt-2`}>
          <span className={`${styles.Blue}`}>*</span> Please choose a Silver, Gold, Gold++, or Platinim Plan in either
          the Enterprise or Standard category that best suits your needs.
          </p>
          <p className={`pt-2`}>
          <span className={`${styles.Blue}`}>*</span> The <span className={`${styles.Blue}`}>Silver</span> Plans are for one Commercial, Music Video or Short Film project.
          </p>
          <p className={`pt-2`}>
          <span className={`${styles.Blue}`}>*</span> The <span className={`${styles.Blue}`}>Gold</span> Plans for one Film or TV Series project.
          </p>
          <p className={`pt-2`}>
          <span className={`${styles.Blue}`}>*</span> The <span className={`${styles.Blue}`}>Gold++</span> Plans are for 10 of any combination and the <span className={`${styles.Blue}`}>*</span>platinum for 25 of any combination.
          </p>
          <p className={`pt-2`}>
          <span className={`${styles.Blue}`}>*</span> The <span className={`${styles.Blue}`}>Budget Only</span> Plans are just for the Budgeting software, the Silver allowing 1 Budget 
          to be made, Gold allowing 2, Gold ++ 10 and Platinum 25.
          </p>
          <p className={`pt-2`}>
          <span className={`${styles.Blue}`}>*</span> You may only have one active Platform Project or Budget Only Plan at a time. If needed upgrade to 
          a higher Plan.
          </p>
          <p className={`pt-2`}>
          <span className={`${styles.Blue}`}>*</span> You may <span className={`${styles.Blue}`}>cancel</span> your Subscription Plan at any time.
          </p>
          <p className={`pt-2`}>
          <span className={`${styles.Blue}`}>*</span> Once you purchase a Subscription Plan begin by creating Projects or Budgets
          on the Account page where you will find all the necessary informating needed.
          </p>
          <p className={`pt-2`}>
          <span className={`${styles.Blue}`}>*</span> Please see the <span className={`${styles.Blue}`}>Chart</span> for Subscription Plan details.
          </p>
          <hr className={`mt-2 mb-0`}/>
         </div> 
        </Col>
      </Row>
    </div>
  )
}

export default InfoSub